export enum SocketState {
  DISCONNECTED,
  CONNECTING,
  SUBSCRIBING,
  CONNECTED,
  RECONNECTING,
  FAILED,
}
